(() => {
  if (window.Shopify?.designMode) return;
  const load = (src, done) => {
    const script = document.createElement('script'); script.src = src; script.async = true;
    if (done) script.addEventListener('load', done, {once: true});
    document.head.appendChild(script);
  };
  let merchantStarted = false;
  const startMerchant = () => {
    if (merchantStarted) return;
    merchantStarted = true;
    ['pointerdown', 'keydown', 'scroll'].forEach(type => window.removeEventListener(type, startMerchant));
    const run = () => {
      load('https://www.gstatic.com/shopping/merchant/merchantwidget.js', () => {
        window.merchantwidget?.start({ position: 'LEFT_BOTTOM', sideMargin: '36', bottomMargin: '36', mobileSideMargin: '16', mobileBottomMargin: '46', merchant_id: '5852664197' });
      });
    };
    if ('requestIdleCallback' in window) requestIdleCallback(run, {timeout: 2000});
    else setTimeout(run, 0);
  };
  ['pointerdown', 'keydown', 'scroll'].forEach(type => window.addEventListener(type, startMerchant, {passive: true, once: true}));
  const afterContent = () => setTimeout(() => {
    const run = () => {
      window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
      const syncConsent = () => {
        const privacy = window.Shopify?.customerPrivacy;
        if (!privacy) return;
        window.clarity('consentv2', {
          ad_Storage: privacy.marketingAllowed() ? 'granted' : 'denied',
          analytics_Storage: privacy.analyticsProcessingAllowed() ? 'granted' : 'denied', source: 101
        });
      };
      document.addEventListener('visitorConsentCollected', syncConsent);
      window.Shopify?.loadFeatures?.([{name: 'consent-tracking-api', version: '0.1'}], error => { if (!error) syncConsent(); });
      load('https://www.clarity.ms/tag/yjsi7j4pnp?ref=shopify');

    };
    if ('requestIdleCallback' in window) requestIdleCallback(run, {timeout: 3000}); else setTimeout(run, 0);
  }, 3500);
  if (document.readyState === 'complete') afterContent(); else window.addEventListener('load', afterContent, {once:true});
})();

